import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { fetchLoyaltyVouchers, useDispatch, useSelector } from "@jti/store";
import { useLoyalty } from "../../hooks/useLoyalty";
import { useLoyaltyStatus } from "../../hooks/useLoyaltyStatus";
import getCartItemsCount from "../../utils/getCartItemsCount";
export const CampaignRunner = () => {
    const [campaignOrderData, setCampaignOrderData] = useState();
    const subtotalIncludingTax = useSelector((state) => state.cart.prices.data?.subtotalIncludingTax.value);
    const items = useSelector((state) => state.cart.items);
    const minimumPayableAmount = useSelector((state) => state.cart.minimumPayableAmount?.value);
    const { loyaltyCampaignId, handleCampaignChange, vouchers } = useLoyalty();
    const dispatch = useDispatch();
    const isLoyaltyActive = useLoyaltyStatus();
    const itemsCount = getCartItemsCount(items);
    const status = useLoyaltyStatus();
    useEffect(() => {
        if (loyaltyCampaignId && status && vouchers.length) {
            const item = vouchers.find(({ campaign_id }) => campaign_id === loyaltyCampaignId);
            if ((item && !item?.is_eligible) || !itemsCount) {
                handleCampaignChange("");
            }
        }
    }, [itemsCount, loyaltyCampaignId, vouchers, status]);
    useEffect(() => {
        if (!subtotalIncludingTax || items.length < 1)
            return;
        const campaignItems = {};
        items.forEach((item) => {
            const categories = item.categories?.map((category) => category.uid);
            campaignItems[item.sku] = { ...(categories && { categories }), price: item.price.value, qty: item.quantity };
        });
        const data = {
            ...(minimumPayableAmount ? { minimumPayableAmount } : {}),
            items: campaignItems,
            orderTotal: subtotalIncludingTax,
        };
        setCampaignOrderData(data);
    }, [minimumPayableAmount, items.length, subtotalIncludingTax]);
    useEffect(() => {
        if (isLoyaltyActive && campaignOrderData) {
            dispatch(fetchLoyaltyVouchers(campaignOrderData));
        }
    }, [dispatch, isLoyaltyActive, campaignOrderData]);
    return _jsx(_Fragment, {});
};
//# sourceMappingURL=CampaignRunner.js.map